module.exports = __webpack_public_path__ + "static/media/yuvraj.a654078f.png";